<template>
  <div class="form">
    <div class="form__header">
      <h3>{{data ? 'Редактировать тренажёр' : 'Добавить тренажёр' }}</h3>
    </div>

    <div class="form__body">
      
      <p class="form__field range">
        <span>Количество: ({{ trainerData.qnt }})</span>
        <range-slider
          class="setup__range"
          min="1"
          max="30"
          step="1"
          v-model="trainerData.qnt">
        </range-slider>
      </p>
      <p class="form__field" v-if="is_dynamic">
        <span>Дата старта:</span>
        <date-picker
          v-model="trainerData.date"
          :value-type="'DD.MM.YYYY'"
          :disabled-date="date => date < disabledDate"
        ></date-picker>
      </p>
      <p class="form__field">
        <span>Ученики: </span>
        <v-select label="name" :options="class_students" v-model="trainerData.students" :multiple="true" :reduce="option => option.id">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>                
      </p>

      <p class="form__checkbox">
        <input type="checkbox" v-model="allStudents" @change="selectStudents" id="all-students">
        <label for="all-students">Все ученики</label>
      </p>

      <p class="form__field">
        <span>Тренажер:</span>        
        <v-select 
          @input="getTrainerSettings(trainer), trainerData.settings = []" 
          label="title" 
          :options="trainersList" 
          v-model="trainer" 
          :appendToBody="false"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.title }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.title }}
            </div>
          </template>
        </v-select>        
      </p>

      <component 
        class="instructions"
        :is="trainerSettings" 
        @params_changed="changeTrainerParams"
        :is_homework="true"
        :homework_params="data ? data.params : null"
      ></component>
    </div>

    <div class="form__footer">
      <button 
        type="button" 
        class="uk-button uk-button-primary" 
        :disabled="!trainerSettings" 
        @click="submit"
      >
        {{ data ? 'Изменить' : 'Добавить'}}
      </button>
    </div> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RangeSlider from 'vue-range-slider'
export default {
  props: ['data', 'class_students', 'is_dynamic'],
  components: { RangeSlider },
  data() {
    return {
      allStudents: false,
      trainer: null,
      trainerSettings: null,
      trainerData: {
        date: null,
        trainer: null,
        params: {},
        settings: [],
        students: [],
        qnt: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      trainers: 'train/trainers'
    }),
    disabledDate() {
      let current = new Date()
      current.setDate(current.getDate() - 2)

      return current
    },
    trainersList() {
      let list = _.cloneDeep(this.trainers)
      list = list.filter(item => item.component !== 'abacus')

      if (!this.is_dynamic) {
        let book = {
          id: null,
          component: 'book',
          title: 'Работа в тетради'
        }
        list.push(book)
      }
      
      return list      
    }
  },
  methods: {
    selectStudents() {
      this.trainerData.students = this.allStudents ? this.class_students.map(item => item.id) : []
    },
    changeTrainerParams(params) {
      console.log(params)
      this.trainerData.params = Object.assign({}, params)
      this.$emit('data-changed')
    },
    getTrainerSettings(trainer) {
      this.trainerData.trainer = {
        id: trainer.id,
        title: trainer.title,
        component: trainer.component
      }
      
      this.trainerSettings = require(`../../trainer/${trainer.component}/components/Settings`).default;
    },
    submit() {
      if (!this.data) {
        this.$emit('add-trainer', this.trainerData)
      }
      this.$emit('close-popup')
    }
  },
  created() {
    if (this.data) {
      this.trainerData = this.data 
      
      if (this.data.trainer) {
        this.getTrainerSettings(this.data.trainer)
         
        this.trainer = this.data.trainer 

        //###### для старых тренажеров #########
        let val = {
          train: this.trainer.component + '_params',
          params: this.data.params,
        }
        this.$store.commit('train/changeParams', val);
        // #################
      } else {
        // работа в тетради
        let trainer = {
          id: null,
          title: this.data.params.title,
          component: this.data.params.code,
          desc: this.data.params.desc
        }
        this.trainer = trainer 
        this.getTrainerSettings(trainer)
      }         
    } else {
      if (this.is_dynamic) {
        this.trainerData.date = new Date().toLocaleDateString('ru-RU')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  min-height: 400px;
}

.instructions {
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
}

.range {
  align-items: center;
  font-size: 16px;
}

.range-slider {
  width: 100%;
}
</style>